import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  name: 'MdmIcon',
  functional: true,
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '50'
    },
    width: {
      type: String,
      default: 'width'
    },
    height: {
      type: String,
      default: 'height'
    },
    title: {
      type: String,
      default: ''
    }
  },
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data;
    var currentWidth = props.width !== 'width' ? props.width : props.size;
    var currentHeight = props.height !== 'height' ? props.height : props.size;
    var currentTitle = props.title ? h("title", [props.title]) : null;
    var svg = {
      attrs: {
        viewBox: "0 0 ".concat(currentWidth, " ").concat(currentHeight),
        width: currentWidth,
        height: currentHeight,
        role: 'img'
      }
    };
    var use = {
      attrs: {
        'xlink:href': "#".concat(props.name)
      }
    };
    return h("svg", _mergeJSXProps2([{}, svg, {}, data]), [currentTitle, h("use", _mergeJSXProps([{}, use]))]);
  }
};